export const publicationStatusOptions = [
  { label: "Draft", value: "draft" },
  { label: "Published", value: "published" }
];